import type { RouteRecordRaw } from 'vue-router';
import AuthenticatedLayout from '@/layouts/AuthenticatedLayout.vue';
import UnauthenticatedLayout from '@/layouts/UnauthenticatedLayout.vue';
import { routes as authenticatedRoutes } from './authenticatedRoutes';
import { routes as unauthenticatedRoutes } from './unauthenticatedRoutes';

export const routes: RouteRecordRaw[] = [
    {
        path: '',
        children: [
            {
                path: '',
                redirect: { name: 'dashboard' },
                component: AuthenticatedLayout,
                meta: {
                    requiresAuth: true,
                },
                children: authenticatedRoutes,
            },
            {
                path: '',
                component: UnauthenticatedLayout,
                meta: {
                    requiresNotAuth: true,
                },
                children: unauthenticatedRoutes,
            },
        ],
    },
];
